import { TableRow, TableRowProps } from "@mui/material";
import {
    TABLE_HEADER_ROW_FONT_SIZE,
    TABLE_HEADER_ROW_PADDING_X,
    TABLE_HEADER_ROW_PADDING_Y
} from "../constants/table.constants";

export function TableHeaderRow({
   sx,
   ...props
}: TableRowProps) {
    const tableHeaderBackground = 'rgb(225,225,225)';
    const tableHeaderBorderColor = 'rgb(190,190,190)';
    
    return (
        <TableRow
            sx={{
                "& .MuiTableCell-root": {
                    textAlign: 'center',
                    fontWeight: "bold",
                    fontSize: TABLE_HEADER_ROW_FONT_SIZE,
                    paddingX: TABLE_HEADER_ROW_PADDING_X,
                    paddingY: TABLE_HEADER_ROW_PADDING_Y,
                    backgroundColor: tableHeaderBackground,
                    borderTop: "1px solid",
                    borderBottom: "1px solid",
                    borderTopColor: tableHeaderBorderColor,
                    borderBottomColor: tableHeaderBorderColor,
                    borderRight: "1px solid #e0e0e0",
                },
                "& .MuiTableCell-root:last-of-type": {
                    borderRight: "none",
                },
                ...sx,
            }}
            {...props}
        />
    );
}